module.exports = __webpack_public_path__ + "971fbe4aaaf978ba02e59a41ccc557a7.jpg";